import { Injectable } from '@angular/core';
import { SelectedBuildingModel } from './selected-building.model';
import { SelectedParcelModel } from './selected-parcel.model';
import { DamageTo } from '../../claim/components/forms/models/damage-to.enum';

@Injectable({ providedIn: 'root' })
export class SelectedItemUtil {
  private _selectedParcel: SelectedParcelModel | undefined;
  private _selectedBuildings: Array<SelectedBuildingModel> | undefined;

  public set selectedParcel(value: SelectedParcelModel | undefined) {
    if (value) {
      value.type = DamageTo.PROPERTY;
    }
    this._selectedParcel = value;
  }

  public set selectedBuildings(
    value: Array<SelectedBuildingModel> | undefined
  ) {
    value?.forEach((building) => {
      building.type = DamageTo.BUILDING;
    });
    this._selectedBuildings = value;
  }

  public get selectedParcel(): SelectedParcelModel | undefined {
    return this._selectedParcel;
  }

  public get selectedBuildings(): Array<SelectedBuildingModel> | undefined {
    return this._selectedBuildings;
  }

  public removeItem(item: SelectedBuildingModel | SelectedParcelModel): void {
    if (item.type === DamageTo.BUILDING) {
      this._selectedBuildings = this._selectedBuildings?.filter(
        (building) =>
          building.building.buildingNumber !==
          (item as SelectedBuildingModel).building.buildingNumber
      );
    } else {
      item = item as SelectedParcelModel;
      this._selectedParcel = undefined;
    }
  }

  public resetItems(): void {
    this._selectedParcel = undefined;
    this._selectedBuildings = undefined;
  }

  public formatAddress(
    item?: SelectedBuildingModel | SelectedParcelModel,
    parcelIdentifier?: string,
    buildingIdentifier?: string
  ): string {
    if (item) {
      if (item.type === DamageTo.BUILDING) {
        item = item as SelectedBuildingModel;
        return `${item.building.fullAddress} (${item.externalNumber})`;
      } else {
        item = item as SelectedParcelModel;
        return `${item.parcel.location}, ${item.parcel.district} (${item.externalNumber})`;
      }
    } else if (parcelIdentifier) {
      if (parcelIdentifier === this.selectedParcel?.parcel.parcelNumber) {
        let found = this.selectedParcel;
        return `${found.parcel.location}, ${found.parcel.district} (${found.externalNumber})`;
      }
    } else if (buildingIdentifier) {
      const found = this.selectedBuildings?.find(
        (b) => b.building.buildingNumber === buildingIdentifier
      );
      if (found) {
        return `${found.building.fullAddress} (${found.externalNumber})`;
      }
    }
    return '';
  }
}
